module.exports = __webpack_public_path__ + "static/media/durazno-150@3x.929935c8.png";